import { LearnerObjectiveAccessCompactModel, ObjectiveWorkflowState } from '@/api/models/aggregate'

export const generateCourseLink = (oc?: LearnerObjectiveAccessCompactModel | undefined) => {
  if (!oc?.objective?.id || !oc?.id) {
    return undefined
  }

  if (oc.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.state === ObjectiveWorkflowState.inProgress) {
    return `/courses/${oc.objective.id}/view/content`
  }

  if (oc?.objectiveWorkflowAggregate.lastObjectiveWorkflow?.state === ObjectiveWorkflowState.finished) {
    return `/courses/${oc.objective.id}`
  }

  return `/courses/${oc.objective.id}/${oc.id}`
}
